// extracted by mini-css-extract-plugin
export var container = "MonthCalendar-module--container--73398";
export var darkVariant = "MonthCalendar-module--dark-variant--4efb8";
export var header = "MonthCalendar-module--header--e0d80";
export var month = "MonthCalendar-module--month--ada53";
export var monthContainer = "MonthCalendar-module--month-container--384b9";
export var monthInput = "MonthCalendar-module--month-input--f95c6";
export var months = "MonthCalendar-module--months--888aa";
export var whiteVariant = "MonthCalendar-module--white-variant--dba38";
export var year = "MonthCalendar-module--year--4c6d3";
export var yearContainer = "MonthCalendar-module--year-container--23b6e";
export var yearInput = "MonthCalendar-module--year-input--2865c";